<template>
  <tr>
    <td class="is-narrow">
      <figure class="image is-32x32">
        <img class="is-rounded" :src="member.avatar_thumb_url" />
      </figure>
    </td>
    <td>
      <span>{{ member.full_name }}</span>
    </td>
    <td>{{ member.email }}</td>
    <td>
      <template v-if="!member.mine && member.id != group.group_owner_id">
        <b-field>
          <b-select
            v-model="member.group_role"
            placeholder="Role"
            icon="account"
            :loading="isChangingRole"
          >
            <option value="USER">Student</option>
            <option value="GROUP_LEADER">Group Leader</option>
          </b-select>
        </b-field>
      </template>

      <template v-else>
        {{ member.id != group.group_owner_id ? 'Group Leader' : 'Group Owner' }}
      </template>
    </td>
    <td class="is-narrow">
      <template v-if="!member.mine && member.id != group.group_owner_id">
        <template v-if="!member.profile_completed">
          <b-button
            :loading="isSendingInvitation"
            :disabled="isSendingInvitation"
            @click="resendInvitation"
            type="is-primary"
          >
            Resend invitation
          </b-button>
        </template>

        <template v-else>
          <b-button
            type="is-danger"
            @click="removeMember"
            outlined
            :loading="isRemovingMember"
          >
            Remove Member
          </b-button>
        </template>
      </template>
    </td>
  </tr>
</template>

<script>
import User from '@/models/User'
import { mapState } from 'vuex'
export default {
  props: {
    member: {
      type: User
    }
  },
  data() {
    return {
      isSendingInvitation: false,
      isChangingRole: false,
      isLoading: false,
      isRemovingMember: false
    }
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup,
      user: state => state.auth.user
    })
  },
  methods: {
    resendInvitation() {
      this.isSendingInvitation = true
      this.$api
        .post(`/groups/${this.group.id}/members/${this.member.id}/resend`)
        .then(() => {
          this.$buefy.snackbar.open({
            message: 'Member invitation has been sent!',
            type: 'is-success',
            position: 'is-top'
          })
        })
        .catch(() => {})
        .then(() => {
          this.isSendingInvitation = false
        })
    },
    changeRole(newRole, oldRole) {
      this.isChangingRole = true
      this.$api
        .post(
          `/groups/${this.group.id}/members/${this.member.id}/change-role`,
          { role: newRole }
        )
        .then(() => {})
        .catch(err => {
          this.$buefy.snackbar.open({
            message: err.response.data.message,
            type: 'is-danger',
            position: 'is-top'
          })

          this.member.group_role = oldRole
        })
        .finally(() => (this.isChangingRole = false))
    },
    removeMember() {
      this.$buefy.dialog.confirm({
        message: `Are you sure you want to remove <strong>${this.member.full_name}</strong>?`,
        onConfirm: () => {
          this.isRemovingMember = true
          this.$api
            .post(`/groups/${this.group.id}/members/${this.member.id}/remove`)
            .catch(() => {})
            .finally(() => {
              this.isRemovingMember = false
              this.$parent.onMemberAdded()
            })
        }
      })
    }
  },
  watch: {
    'member.group_role': function(newVal, oldVal) {
      this.changeRole(newVal, oldVal)
    }
  }
}
</script>
